import React from "react";
import { ArrowRight, XCircle, CheckCircle2 } from "lucide-react";

const BROKEN = [
  "Expertise",
  "Random content",
  "Unqualified attention",
  "Inconsistent enquiries",
  "Unpredictable revenue",
];

const NEW_JOURNEY = [
  "Expertise",
  "Authority content",
  "Qualified attention",
  "Lead capture",
  "Automated nurturing",
  "Premium clients",
];

export default function ProblemSection() {
  return (
    <section className="relative z-10 px-4 py-10 md:py-14">
      <div className="max-w-6xl mx-auto">
        <p className="text-center text-[#C4FF3D] uppercase tracking-[0.28em] text-[11px] md:text-xs font-bold mb-3">
          The Real Problem
        </p>
        <h2 className="display-font text-center text-3xl md:text-5xl font-extrabold leading-tight mb-4">
          <span className="text-white">The Problem Isn't Your Knowledge.</span>
          <br />
          <span className="text-white">It's</span>{" "}
          <span className="lime-box">The Missing System</span>{" "}
          <span className="text-white">Around It.</span>
        </h2>
        <p className="text-center text-white/65 max-w-3xl mx-auto mb-14">
          Most experts already have world-class knowledge. What's missing is a connected business system that turns that expertise into consistent attention, qualified leads and predictable premium revenue.
        </p>

        {/* Broken journey */}
        <div className="mb-10">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-9 h-9 rounded-xl bg-red-500/15 border border-red-500/40 flex items-center justify-center">
              <XCircle className="w-5 h-5 text-red-400" />
            </div>
            <h3 className="text-white text-lg md:text-xl font-bold">The Broken Journey Most Experts Are Stuck In</h3>
          </div>
          <JourneyRow items={BROKEN} tone="broken" />
        </div>

        {/* New journey */}
        <div>
          <div className="flex items-center gap-3 mb-5">
            <div className="w-9 h-9 rounded-xl bg-[rgba(196,255,61,0.12)] border border-[rgba(196,255,61,0.4)] flex items-center justify-center">
              <CheckCircle2 className="w-5 h-5 text-[#C4FF3D]" />
            </div>
            <h3 className="text-white text-lg md:text-xl font-bold">The New Journey You'll Build Inside The Workshop</h3>
          </div>
          <JourneyRow items={NEW_JOURNEY} tone="new" />
        </div>
      </div>
    </section>
  );
}

function JourneyRow({ items, tone }) {
  const isNew = tone === "new";
  return (
    <div className="flex flex-wrap items-stretch gap-2 md:gap-3">
      {items.map((label, i) => (
        <React.Fragment key={label}>
          <div
            className={`flex-1 min-w-[130px] px-4 py-3.5 rounded-xl text-center text-sm md:text-base font-semibold ${
              isNew
                ? "bg-[rgba(196,255,61,0.08)] border border-[rgba(196,255,61,0.35)] text-white"
                : "bg-[rgba(255,90,90,0.06)] border border-red-500/25 text-white/70"
            }`}
          >
            {label}
          </div>
          {i < items.length - 1 && (
            <div className="flex items-center justify-center">
              <ArrowRight
                className={`w-4 h-4 md:w-5 md:h-5 ${isNew ? "text-[#C4FF3D]" : "text-white/35"}`}
              />
            </div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
}
